const initialState = {
  currentProperty: {
    agentId: {},
    description: {},
    options: {},
    scheme: {},
  },
  paginatedProperties: [],
  agentProperties: [],
  totalCount: 0,
  recommendations: [],
  fetchUrl: null,
  differences: [],
  differencesMapped: {
    description: {},
    options: {},
    option: {},
  },
  agencyRecommendedProperties: [],
  lastFetched: "",
  similar: [],
  tasks: [],
  tasksTotalCount: 0,
  isReservedCode: true,
  isUploadingImages: false,
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case "FETCH_PROPERTIES_BY_AGENT":
      return {
        ...state,
        agentProperties: action.payload,
        tasksTotalCount: action.tasksTotalCount || 0,
        agentPropertiesPagination: action.pagination || null,
      };
    case "FETCH_PROPERTY":
      return {
        ...state,
        currentProperty: {
          ...action.payload,
          options: action.payload.options || {},
        },
        recommendations: action.recommendations,
        differences: action.differences,
        differencesMapped: action.differencesMapped,
        similar: action.similar,
        tasks: action.tasks || [],
      };
    case "FETCH_PROPERTY_CODE_AVAILABILITY":
      return {
        ...state,
        isReservedCode:
          action.payload === "undefined" || action.payload === "unavailable"
            ? true
            : false,
      };
    case "FETCH_PROPERTIES":
      return {
        ...state,
        paginatedProperties: action.payload,
        totalCount: action.totalCount,
        fetchUrl: action.fetchUrl,
        lastFetched: action.lastFetched,
        fetchedParams: action.fetchedParams,
      };
    case "FETCH_AGENCY_PROPERTIES":
      return {
        ...state,
        agencyRecommendedProperties: action.payload,
      };
    case "SET_UPLOADING_IMAGES":
      return {
        ...state,
        isUploadingImages: !!action.payload,
      };
    case "RESET_CURRENT_PROPERTY":
      return {
        ...state,
        currentProperty: initialState.currentProperty,
        recommendations: [],
        differences: [],
        differencesMapped: initialState.differencesMapped,
        similar: [],
        tasks: [],
      };
    default:
      return state;
  }
};
